import React from 'react';
import Project from '../components/Project';

const projects = [
  {
    id: 1,
    title: 'Leios Dojo',
    description: "An immersive 3D view of Cardano's Ouroboros Leios running on the public Musashi Dojo testnet, as seen from my own relay. A Python backend turns node logs into block and endorser-block lifecycles streamed over WebSocket to a TypeScript/React + three.js front-end, with live and history replay, committee votes, and a capacity view.",
		image: '/images/leios_dojo.png',
		link: "https://leios-dojo.netlify.app/"
	},

  {
    id: 2,
    title: 'Evoque Mobile Shopping App',
    description: "Co-authored an e-commerce app featuring a custom loyalty system. Built using React Native for the front-end, a microservice API powered by AWS Lambda (Node.js and Serverless framework), MongoDB for database management, and Stripe for payment processing.",
		image: '/images/evoque_ss.png',
		link: "https://youtu.be/jtL4ZNId1Jk?si=ztonvHX3ov5-hDAg"
	},

  {
    id: 3,
    title: 'Notion Image Reader',
    description: "Notion Image Reader extracts the text from image in a given Notion page. It uses OAuth2.0 for secure access and Google Cloud Platform for it's backend.",
		image: '/images/notion_image_reader.png',
		link: "https://notion-image-reader.netlify.app/"
	},

  {
    id: 4,
    title: 'Crypto Dash App',
    description: "Crypto Dash is a hobby project that aims to provide concise and intuitive visualizations for evaluating key cryptocurrency metrics, including historical price, trend, market capitalization, and ranking.",
		image: '/images/cryptodash.png',
		link: "https://youtu.be/LLGdntqFmH0?si=48x1Zri7q1thGVZF"
	},
	{
    id: 5,
    title: "AIESEC's Digital Transformation",
    description: 'Recommendation system that won the 5th place in International Business Analytic challenge. The project includes an unsupervised model and a prototype to improve Volunteer - Country matching for the Non-Profit. ',
		image: '/images/iba.png',
		link: "https://github.com/CanerIrfanoglu/IBA_challenge"
  },
  {
    id: 6,
    title: 'Jeffrey Trading Bot',
    description: 'Jeffrey is an indicator based, fully automated algorithmic trading bot that is capable of making long and short trades. It is integrated with multiple exchanges.',
		image: '/images/jeffrey.png',

  },
  {
    id: 7,
    title: 'UNB Data Visualization Contest',
    description: 'Data driven analysis based on New Brunswick’s Open Data Portal. Includes a Tableau infographic.',
		image: '/images/hackathon_nb.png',
		link: "https://github.com/CanerIrfanoglu/Data-Visualization-Competition-University-of-New-Brunswick"

  },
  {
    id: 8,
    title: 'Rpubs Projects',
    description: "This projects include the analyses made for Coursera's < Data Science: Foundations using R Specialization >",
		image: '/images/rpubs.png',
		link: "https://rpubs.com/poi"
  },

];



function Projects() {
  return (
    <div className="projects-container">
			<h1 className="text-3xl font-semibold mb-5">projects</h1>
      <div className="project-grid">
        {projects.map((project) => (
          <div className="project-item" key={project.id}>
            <Project {...project} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
